export default __webpack_public_path__ + "static/media/market.e4979735.svg";